<div class="container {{ OBJ_LNG_NAME }} insertEdit">
  <h1 mat-dialog-title>
    {{ 'allgemein.ändern' | translate:locale.language:{ typ: OBJ_LNG_NAME + '.passwort' | translate:locale.language } }}
    <button mat-icon-button type="button" mat-dialog-close><mat-icon aria-label="Schließen">close</mat-icon></button>
    <mat-progress-bar *ngIf="dataService.isRequestRunning" color="primary" mode="indeterminate"></mat-progress-bar>
  </h1>
  <mat-dialog-content>
    <form #inserteditForm="ngForm" (ngSubmit)="speichernAendern()">
      <input matInput [hidden]="true" [ngModel]="aktuell.id" name="id" />

      <p class="errors" *ngIf="dataService.fehler" [innerHTML]="dataService.fehler.messagehtml"></p>

      <mat-form-field class="full-width">
        <input matInput [(ngModel)]="aktuell.login" name="login"  class="full-width" disabled />
		  <mat-label>{{ OBJ_LNG_NAME + '.login' | translate:locale.language }}</mat-label>
      </mat-form-field>

    <mat-form-field class="full-width" [class.ng-invalid]="aktuell.passwortwiederholung != aktuell.passwort" [class.ng-valid]="aktuell.passwortwiederholung == aktuell.passwort">
      <input matInput #passwort="ngModel" [(ngModel)]="aktuell.passwort" name="passwort"
             class="full-width" maxlength="255" type="password" [disabled]="dialogrunningajaxcall" />
		<mat-label>{{ OBJ_LNG_NAME + '.passwort' | translate:locale.language }}</mat-label>
      <mat-hint *ngIf="aktuell.passwort != passwortwiederholung.value">{{ 'allgemein.validierung.nichtgleich' | translate:locale.language:{ typ: OBJ_LNG_NAME + '.passwort' | translate:locale.language, typvergl: OBJ_LNG_NAME + '.passwortwiederholung' | translate:locale.language } }}</mat-hint>
      <mat-hint class="pwdhint" *ngIf="aktuell.passwort != null && aktuell.passwort !== ''" align="end">
		<ngx-password-strength-bar class="psb" *ngIf="aktuell.passwort != null && aktuell.passwort !== ''" [passwordToCheck]="aktuell.passwort" [barLabel]="getPasswortStaerke(aktuell.passwort)"></ngx-password-strength-bar>
<!--      test-->
	  </mat-hint>
    </mat-form-field>

    <mat-form-field class="full-width" [class.ng-invalid]="aktuell.passwortwiederholung != aktuell.passwort" [class.ng-valid]="aktuell.passwortwiederholung == aktuell.passwort">
      <input matInput #passwortwiederholung="ngModel" [(ngModel)]="aktuell.passwortwiederholung" name="passwortwiederholung"
              class="full-width" maxlength="255" type="password" [disabled]="dialogrunningajaxcall" />
      <!--      <mat-hint *ngIf="passwortwiederholung.errors && (passwortwiederholung.dirty || passwortwiederholung.touched) && passwortwiederholung.errors.required">{{ 'allgemein.validierung.nichtleer' | translate:locale.language:{ typ: OBJ_LNG_NAME + '.passwortwiederholung' | translate:locale.language } }}</mat-hint>-->
      <mat-label>{{ OBJ_LNG_NAME + '.passwortwiederholung' | translate:locale.language }}</mat-label>
		<mat-hint *ngIf="aktuell.passwortwiederholung != aktuell.passwort">{{ 'allgemein.validierung.nichtgleich' | translate:locale.language:{ typ: OBJ_LNG_NAME + '.passwortwiederholung' | translate:locale.language, typvergl: OBJ_LNG_NAME + '.passwortneu' | translate:locale.language } }}</mat-hint>
      <mat-hint *ngIf="passwortwiederholung.value" align="end">{{ passwortwiederholung.value.length }} / 255</mat-hint>
    </mat-form-field>

    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">

    <button mat-raised-button type="button" (click)="close()" [disabled]="dialogrunningajaxcall">{{ 'allgemein.abbrechen' | translate:locale.language }}</button>
    <!--<button mat-raised-button type="submit" (click)="speichernAendern()" color="primary" [disabled]="!inserteditForm.form.valid || dialogrunningajaxcall">-->
      <!--<mat-spinner *ngIf="dialogrunningajaxcall"></mat-spinner>-->
      <!--{{ (dialogrunningajaxcall ? 'allgemein.daten.verarbeiten' : (neu ? 'allgemein.neu' : 'allgemein.speichern')) | translate:locale.language:{ typ: OBJ_LNG_NAME+'.typ' | translate:locale.language } }}-->
    <!--</button>-->

    <button mat-raised-button type="submit" (click)="speichernAendern()" color="primary" [disabled]="!inserteditForm.form.valid || !aktuell.passwort || aktuell.passwort != aktuell.passwortwiederholung || dialogrunningajaxcall">
      <mat-spinner *ngIf="dialogrunningajaxcall"></mat-spinner>
      {{ (dialogrunningajaxcall ? 'allgemein.daten.verarbeiten' : 'allgemein.ändern') | translate:locale.language:{ typ: OBJ_LNG_NAME + '.passwort' | translate:locale.language } }}
    </button>

  </mat-dialog-actions>
</div>

